import { EmptyState, Link, Text } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { useContext } from "react"
import { PayrollContext } from "../../../contexts/PayrollContext/PayrollContext"
import { companyUnpaidInvoicesPath } from "@oysterhr/invoicing"
import { useAccountAspect } from "@oysterhr/identity"

export const PayrollChangeFTERestricted = () => {
  const { t } = useTranslation("Payroll")
  const { companyId } = useContext(PayrollContext)
  const { isStaff } = useAccountAspect()
  const aspect = isStaff ? "staff" : "customer"

  return (
    <div className="flex flex-col items-center gap-2">
      <img
        src={EmptyState.Illustration.secure1}
        className="w-12"
        alt={t(`restrictions.addPayrollChangeModal.${aspect}.titleSelectedFTE`)}
      />
      <div className="flex flex-col items-center gap-4">
        <Text className="text-center font-semibold">
          {t(`restrictions.addPayrollChangeModal.${aspect}.titleSelectedFTE`)}
        </Text>
        <Text className="text-center">
          {t(`restrictions.addPayrollChangeModal.${aspect}.contentSelectedFTE`)}
        </Text>
        <Link
          to={companyUnpaidInvoicesPath({ companyId: companyId, isStaff })}
          className="text-center"
        >
          {t("restrictions.addPayrollChangeModal.viewUnpaidInvoices")}
        </Link>
      </div>
    </div>
  )
}
